type FormatNumberParams = {
	value: number;
	locale?: string;
	options?: Intl.NumberFormatOptions;
};

export const formatNumber = ({ value, locale, options }: FormatNumberParams) =>
	new Intl.NumberFormat(locale || "en", options).format(value);
